"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// COLORS
const style = "normal";
const brand = "#C5E6F1";
const headerBackgroundColor = brand;
const headerTextColor = "#000000";
const mainInfoLandscape = headerTextColor;
const mainInfoPortrait = headerTextColor;
const fontFamily = `
    @font-face {
    font-family: 'made_canvas';
    src: 
        url('/fonts/made-canvas/made-canvas-regular.woff') format('woff'),
        url('/fonts/made-canvas/made-canvas-regular.woff2') format('woff');
    font-weight: 400;
    font-style: normal;
    }

    @font-face {
    font-family: 'made_canvas';
    src: 
        url('/fonts/made-canvas/made-canvas-bold.woff') format('woff'),
        url('/fonts/made-canvas/made-canvas-bold.woff2') format('woff');
    font-weight: 700;
    font-style: normal;
    }

    @font-face {
    font-family: 'made_canvas';
    src: 
        url('/fonts/made-canvas/made-canvas-light.woff') format('woff'),
        url('/fonts/made-canvas/made-canvas-light.woff2') format('woff');
    font-weight: 200;
    font-style: normal;
    }
    html {
        font-family: "made_canvas", sans-serif ;
    }
`;
exports.default = {
    brand,
    mainInfoLandscape,
    mainInfoPortrait,
    headerBackgroundColor,
    headerTextColor,
    fontFamily,
    style,
};
